import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { FeedbackVisibilityDisplayOptions } from '@app/types/translatables/feedback-display.options';

export class VisibilityColumn extends Column {
    title = 'performance.feedbackColumns.visibility';
    property = 'visibility';
    sortField = 'visibility';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    constructor() {
        super();

        const options = [
            {
                label: FeedbackVisibilityDisplayOptions.public,
                value: 'public',
            },
            {
                label: FeedbackVisibilityDisplayOptions.private,
                value: 'private',
            },
            {
                label: FeedbackVisibilityDisplayOptions.manager,
                value: 'manager',
            },
            {
                label: FeedbackVisibilityDisplayOptions.admin,
                value: 'admin',
            },
        ];

        this.filter = new CheckListFilter('visibility', options);
    }
}
